import { getShareLessonProperties, ShareButton } from '@mc/share'
import { useStaticData } from '@mc/static-data-react'

import CTA from 'components/CTA'
import Sticky from 'components/Sticky'

const StickyFooter = () => {
  const { course, chapter } = useStaticData()

  return (
    <Sticky>
      <div
        className='container d-flex align-items-center justify-content-end mc-py-4'
        data-testid='sticky-footer'
      >
        <ShareButton {...getShareLessonProperties(course, chapter)} />
        <CTA
          className='mc-ml-4'
          trackProps={{
            content_type: 'product',
            location: 'sticky',
          }}
        />
      </div>
    </Sticky>
  )
}

export default StickyFooter
